import dayjs from "config/dayjs"
import { useVenueController } from "hooks/venue/useVenueController"
import { ImdfFeature } from "providers/venue/types"
import _ from "lodash"
import { useGeoLocation } from "providers/geolocation"
import { useVenue } from "providers/venue"
import { useCallback, useMemo } from "react"
import { useSearchParams } from "react-router-dom"
import { Q_VENUE } from "constant"

type FilterByVenueId = (venueId: string) => void

export const useNewShops = (occupants: ImdfFeature[]) => {
  const currentDate = dayjs()
  const { isMultiVenueProject, venues, pageConfig } = useVenue()

  const { locationVenue } = useGeoLocation()
  const locationVenueId = _.get(locationVenue, "id")
  const periodInDays = _.get(pageConfig, "newShop.metadata.periodInDays")
  const { viewingVenue: venueFilter } = useVenueController(locationVenueId)
  const [, setSearchParams] = useSearchParams()

  const filterByVenueId: FilterByVenueId = useCallback(
    (venueId) => {
      if (venueId) setSearchParams({ [Q_VENUE]: venueId }, { replace: true })
    },
    [setSearchParams]
  )

  const newOccupantFilter = (feature: ImdfFeature) => {
    const { properties } = feature || {}
    return (
      currentDate.isSameOrAfter(properties.start_date) &&
      currentDate.diff(dayjs(properties.start_date), "day") <= periodInDays
    )
  }

  const comingSoonOccupantFilter = (feature: ImdfFeature) => {
    return currentDate.isBefore(dayjs(feature.properties.start_date))
  }

  const viewingVenueOccupants = useMemo(
    () =>
      occupants.filter(({ properties }) => properties.venue_id === venueFilter),
    [occupants, venueFilter]
  )
  const getOccupantsByStartDate = useMemo(() => {
    return viewingVenueOccupants.filter(
      ({ properties }) => properties.start_date
    )
  }, [viewingVenueOccupants])

  const newOccupants = getOccupantsByStartDate.filter(newOccupantFilter)
  const comingSoonOccupants = getOccupantsByStartDate.filter(
    comingSoonOccupantFilter
  )

  const isNotEmptyNewOccupantList = _.size(newOccupants) > 0
  const isNotEmptyComingSoonOccupantList = _.size(comingSoonOccupants) > 0
  const hasData = isNotEmptyNewOccupantList || isNotEmptyComingSoonOccupantList

  return {
    newOccupants,
    comingSoonOccupants,
    isNotEmptyNewOccupantList,
    isNotEmptyComingSoonOccupantList,
    hasData,
    isMultiVenueProject,
    locationVenueId,
    venues,
    venueFilter,
    // Function
    filterByVenueId,
  }
}
